import { form, g, initWallet, log, openModal_v2, t } from '../../../../utils'
import '../../assets/css/style.min.css'
import { firebaseConfig } from '../../components/config';

initWallet(firebaseConfig.messagingSenderId, (mResult) => {
    g("_bal").innerText = `KWA${mResult.balance}`
})

form("recharge", (data) => {
    var currentdate = new Date();

    const info = {
        "banking": {
            "swiftCode": "FIRNZMLX",
            "branchName": "Ndola Branch",
            "accountNumber": "62863009447",
            "branchCode": "260103",
            "bankName": "First National Bank (FNB)",
            "accountName": "PICKANAPP ZAMBIA"
        },
        "contact": {
            "address": " <p>Stand number 2470</p><p>Maina Soko Road,</p><p>Town Center, Ndola, Zambia</p>",
            "email": "info@pickan.app",
            "phone": "+260963454336"
        },
        "company": "PICKANAPP ZAMBIA"
    }

    const dashboardData = {
        "@package": {
            "seconds": 1693148307,
            "nanoseconds": 646000000
        },
        "package": "basic",
        "nextStep": 4,
        "companyPhone": "+260960161324",
        "figure": "https://firebasestorage.googleapis.com/v0/b/pickaapp-79307.appspot.com/o/dashboard%2F7boeTTBBvPd6VCFwQqKWPlkYKmf1%2FKudu%20ride%20photo.png?alt=media&token=423d338d-8390-4f78-a574-a6166ffde128",
        "accountNumber": "32020000831625",
        "name": "Kudu Ride",
        "address": "55804, off Tokyo Way, Lusaka, 10101, Zambia",
        "billingCycle": "monthly",
        "description": "Kudu Ride provides a marketplace where individuals seeking transportation can seamlessly order a taxi or hire a car online. Three simple steps will get you to your next destination: Download the Kudu Ride app on Google Play Store – Register with your phone number or Google account and order your ride. Our app is a 2-in-1 with both driver and rider application in one space.",
        "timestamp": {
            "seconds": 1693147271,
            "nanoseconds": 739000000
        },
        "email": "kuduride@gmail.com",
        "companyEmail": "kuduride@gmail.com",
        "company": "Kudu Ride LTD"
    }

    const banking = info.banking
    const contact = info.contact

    var description = "Prepaid Wallet Recharge"
    var managementFee = 0
    var discount = 0
    var other = 0
    var mPayment = 9884

    var total;

    const primaryAmount = parseFloat(data["amount"])
    total = primaryAmount

    total += managementFee
    total += other

    g("app").appendChild(t(`<div class="">
        <header class="invoice__section invoice__section--bg">
            <ul class="grid">
                <li class="col-6">
                    <svg class="invoice__logo" xmlns="http://www.w3.org/2000/svg" width="73" height="80" viewBox="0 0 73 80" fill="none">
                        <circle cx="36.4111" cy="35.6237" r="35.6063" fill="#666666"/>
                        <circle cx="36.4111" cy="35.6237" r="31.0279" fill="black"/>
                        <circle cx="22.9929" cy="57.8118" r="22.1882" fill="#666666"/>
                        <circle cx="22.9929" cy="57.8118" r="17.6096" fill="black"/>
                    </svg>
                </li>

                <li class="col-6">
                    <ul class="grid gap-y-lg">
                        <li class="col-6 padding-right-sm">
                            <p class="invoice__label">Invoice No.
                            </p>

                            <div
                                class="text-component text-sm line-height-xs text-space-y-xs color-contrast-medium">
                                <p>PREPAID</p>
                            </div>
                        </li>

                        <li class="col-6 padding-right-sm">
                            <p class="invoice__label">Date</p>

                            <div
                                class="text-component text-sm line-height-xs text-space-y-xs color-contrast-medium">
                                <p>${currentdate}</p>
                            </div>
                        </li>

                        <li class="col-6 padding-right-sm">
                            <p class="invoice__label">Issued By</p>

                            <div
                                class="text-component text-sm line-height-xs text-space-y-xs color-contrast-medium">
                                <p>${info.company}</p>
                                <p>${contact.address}</p>
                            </div>
                        </li>

                        <li class="col-6 padding-right-sm">
                            <p class="invoice__label">Bill To</p>

                            <div class="text-component text-sm line-height-xs text-space-y-xs color-contrast-medium">
                                <p>${dashboardData.company}</p>
                                <p>${dashboardData.address}</p>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
        </header>

        <div class="invoice__section">
            <table class="invoice__table" aria-label="Items list table">
                <thead class="border-bottom border-contrast-lower border-opacity-50%">
                    <tr>
                        <th class="invoice__table-cell font-semibold color-contrast-higher width-50%"
                            scope="col">Description</th>
                        <th class="invoice__table-cell font-semibold color-contrast-higher width-25%"
                            scope="col">Qty</th>
                        <th class="invoice__table-cell font-semibold color-contrast-higher width-25%"
                            scope="col">Price</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td class="invoice__table-cell color-contrast-medium" role="cell">${description}</td>

                        <td class="invoice__table-cell color-contrast-medium" role="cell">1</td>

                        <td class="invoice__table-cell color-contrast-medium" role="cell">ZMW${primaryAmount}</td>
                    </tr>

                    <tr>
                        <td class="invoice__table-cell color-contrast-medium" role="cell">${"Account Management"}</td>

                        <td class="invoice__table-cell color-contrast-medium" role="cell">1</td>

                        <td class="invoice__table-cell color-contrast-medium" role="cell">ZMW${managementFee}</td>
                    </tr>

                    <tr>
                        <td class="invoice__table-cell color-contrast-medium" role="cell">${"Other"}</td>

                        <td class="invoice__table-cell color-contrast-medium" role="cell">1</td>

                        <td class="invoice__table-cell color-contrast-medium" role="cell">ZMW${other}</td>
                    </tr>
                </tbody>
            </table>

            <div class="border-top border-contrast-lower border-opacity-50% margin-bottom-xl">
                <div class="grid">
                    <div class="col-6 offset-6">
                        <table class="invoice__table"
                            aria-label="Order summary table">
                            <tbody>
                                <tr>
                                    <th class="invoice__table-cell width-50% color-contrast-medium">Subtotal</th>
                                    <td class="invoice__table-cell width-50% color-contrast-medium">
                                        ZMW${total}
                                    </td>
                                </tr>

                                <tr>
                                    <th class="invoice__table-cell color-contrast-medium">
                                        Digital Service Tax
                                    </th>
                                    <td class="invoice__table-cell color-contrast-medium">
                                        N/A <a href="https://zambiataxplatform.com/leveraging-on-the-digital-economy-to-improve-tax-revenue-performance-in-zambia/#:~:text=Currently%2C%20Zambia%20has%20no%20digital,such%20as%20Ghana%20and%20India." target="_blank">Learn more</a>
                                    </td>
                                </tr>

                                <tr>
                                    <th class="invoice__table-cell font-semibold color-contrast-higher">Total</th>
                                    <td class="invoice__table-cell font-semibold color-contrast-higher"><u>ZMW${total}</u></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="grid gap-md">
                <div class="col-6@md">
                    <p class="invoice__label">Payment Method</p>

                    <div
                        class="text-component text-sm line-height-xs text-space-y-xs color-contrast-medium">
                        <p>${banking.bankName}</p>
                        <p>Account Name: ${banking.accountName}</p>
                        <p>Account Number: ${banking.accountNumber}</p>
                        <p>SWIFT: ${banking.swiftCode}</p>
                        <p>Branch name, code: ${banking.branchName} ${banking.branchCode}</p>
                    </div>
                </div>

                <div class="col-6@md">
                    <p class="invoice__label">Notes</p>

                    <div
                        class="text-component text-sm line-height-xs text-space-y-xs color-contrast-medium">
                        <p>Please retain the deposit slip or transfer receipt as proof of payment.</p>
                    </div>
                </div>
            </div>
        </div>

        <footer class="invoice__section invoice__section--bg">
            <div class="grid">
            <div class="col-6">
                <p class="invoice__paid-stamp">

                </p>
            </div>

            <div class="col-3 offset-3">
                <p class="invoice__label">Questions?</p>

                <div class="text-component text-sm line-height-xs text-space-y-xs">
                    <p><a href="mailto:${contact.email}">${contact.email}</a></p>
                    <p><a href="tel:${contact.phone}">${contact.phone}</a></p>
                </div>
            </div>
            </div>
        </footer>
    </div>`))

    openModal_v2("modal-form", () => { })
})

require("../../assets/js/scripts")